import Template from '../../component/Template.js';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Select from 'react-select'; //04-03-2024-multiselect

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';
import { Link } from 'react-router-dom';
import React, { useRef } from "react";

import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import $ from 'jquery';


export default function UpdateCollegeLevelEventsList() {
  const [flag, setflag] = useState(false);
  const tableRef = useRef(null);
  {/*------------------------------------*/ }
  /* CUSTOM DATA TABLE BEGIN HERE */
  const [tableData, setTableData] = useState([]);
  const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' }); //sort
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total_count, setTotal] = useState(null);

  const [reload, setReload] = useState(false);
  const [isDeleteUser, setDeleteUser] = useState(false);
  const [deleteUserID, setDeleteUserID] = useState(false);
  const [deleteUserDiscID, setDeleteUserDiscID] = useState(null);
  const [deleteUserCourseType, setDeleteUserCourseType] = useState(null);
  const [allActiveEvents, setAllActiveEvents] = useState([]);
  const [selectedEvents, setSelectedEvents] = useState(null);
  const [selectedEventID, setSelectedEventID] = useState(null);

  /* CUSTOM DATA TABLE END HERE */


  const { http } = Api();
  const navigate = useNavigate();

  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/college/");
  }


  let cid = localStorage.getItem("collegeid");
  let collegename = localStorage.getItem("username");

  useEffect(() => {
    const fetchAllActiveEvents = () => {
      http.get('/Admin/getCollegeEvents')
        .then((response) => {
          setAllActiveEvents(response.data);
        }).catch((error) => {
          if (error.response?.data?.http_status === 401 && error.response.data.status_code === "ERR9") {
            toast.error("Invalid Token");
            setTimeout(() => {
              navigate("/admin/");
            }, 5000);
          }
          else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
            toast.error(error.response.data.message);
          }
          else {
            toast.error("Something went wrong");
          }
        });
    };
    fetchAllActiveEvents();

  }, [reload]);

  const handleEventChange = (selectedOption) => {
    setSelectedEvents(selectedOption);
    setSelectedEventID(selectedOption ? selectedOption.value : null);
  };


  useEffect(() => {

    const event_id = selectedEventID ? selectedEventID : null;

    const getAllactiveEvents = async () => {
      try {
        const response = await http.get(`/Admin/getAllCollegeActiveEvents`, {
          params: {
            limit: '500',
            event_id: selectedEventID
          }
        });
        if (response.data.status_code === 'ERR5') {
          setflag(true);
        }
        if (Array.isArray(response.data)) {
          setTableData(response.data);
        }
        else if (Array.isArray(response.data.data)) {
          setTableData(response.data.data);
        } else {
          setTableData([]);
        }

      }
      catch (error) {
        console.log("error==", error)
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/admin/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };


    getAllactiveEvents();


  }, [selectedEventID, reload]);


  /* DATA TABLE  */

  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSort = (column) => {
    const newSortBy = {
      column,
      direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
    };
    setSortBy(newSortBy);
  };

  // useEffect(() => {
  //   if (!Array.isArray(tableData)) {
  //     setfilteredAndSortedData([]);
  //     setTotal(0);
  //     setTotalPages(0);
  //     return;
  //   }
  //   const filteredAndSortedData = [...tableData].filter(tableDatas => {
  //     return (
  //       tableDatas.event_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
  //       tableDatas.college_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
  //       tableDatas.scheme_id.toLowerCase().includes(searchQuery.toLowerCase()) ||
  //       tableDatas.start_date.toLowerCase().includes(searchQuery.toLowerCase()) ||
  //       tableDatas.end_date.toLowerCase().includes(searchQuery.toLowerCase()) ||
  //       tableDatas.status.toString().toLowerCase().includes(searchQuery.toLowerCase())

  //     );
  //   }).sort((a, b) => {
  //     if (sortBy.direction === 'asc') {
  //       return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
  //     } else {
  //       return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
  //     }
  //   });

  //   const itemsPerPage = 50;
  //   const startIndex = (currentPage - 1) * itemsPerPage;
  //   const paginatedData = filteredAndSortedData.slice(startIndex, startIndex + itemsPerPage);

  //   setfilteredAndSortedData(paginatedData);
  //   setTotalPages(Math.ceil(filteredAndSortedData.length / itemsPerPage));
  //   setTotal(filteredAndSortedData.length);

  // }, [searchQuery, sortBy, tableData, currentPage]);

   const toSearchableString = (value) => {
    if (value === null || value === undefined) return '';
    return value.toString().toLowerCase();
  };

  useEffect(() => {
    if (!Array.isArray(tableData)) {
      setfilteredAndSortedData([]);
      setTotal(0);
      setTotalPages(0);
      return;
    }

    const query = searchQuery.toLowerCase();

    const filteredAndSortedData = [...tableData]
      .filter(item => {

        // map scheme_id → scheme name
        const schemeName = {
          1: 'mgu-ugp',
          2: 'bba',
          3: 'bca',
          4: 'b.voc'
        }[item.scheme_id] || '';

        return (
          toSearchableString(item.event_name).includes(query) ||
          toSearchableString(item.college_name).includes(query) ||

          // 🔥 Admission Year, Semester, Scheme (4th column)
          toSearchableString(item.admission_year).includes(query) ||
          toSearchableString(item.semester_id).includes(query) ||
          schemeName.includes(query) ||

          toSearchableString(item.start_date).includes(query) ||
          toSearchableString(item.end_date).includes(query) ||
          toSearchableString(item.status).includes(query)
        );
      })
      .sort((a, b) => {
        if (!sortBy.column) return 0;

        const aVal = toSearchableString(a[sortBy.column]);
        const bVal = toSearchableString(b[sortBy.column]);

        return sortBy.direction === 'asc'
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
      });

    const itemsPerPage = 50;
    const startIndex = (currentPage - 1) * itemsPerPage;

    setfilteredAndSortedData(
      filteredAndSortedData.slice(startIndex, startIndex + itemsPerPage)
    );

    setTotalPages(Math.ceil(filteredAndSortedData.length / itemsPerPage));
    setTotal(filteredAndSortedData.length);

  }, [searchQuery, sortBy, tableData, currentPage]);

  const renderSortIcon = (columnName) => {
    if (sortBy.column === columnName) {
      return sortBy.direction === 'asc' ? <i className="fa fa-sort-up ml-1" aria-hidden="true"></i> : <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
    }
    return <i className="fa fa-sort ml-1" aria-hidden="true"></i>; // Show disabled sort icon
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  /* DATA TABLE END */

  const handleToggleStatus = async (pk_id, status) => {
    const action = status === 'active' ? 'closed' : 'active';

    try {
      const response = await http.post(`/Admin/ChangeCollegeEventStatus`, null, {
        params: {
          pk_id: pk_id,
          action: action
        }
      });

      if (response.data.status_code === 'ERR5') {
        setflag(true);
        return;
      }
      if (response.data.status_code === 'MSG2' || response.data.http_status === 200) {
        toast.success("Event status updated successfully");
        setReload(!reload);
      }
    }
    catch (error) {
      if (error.response?.data?.http_status === 401 && error.response.data.status_code === "ERR9") {
        toast.error("Invalid Token");
        setTimeout(() => navigate("/admin/"), 5000);
      } else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong");
      }
    }
  };
  const handleClearFields = () => {

    setAllActiveEvents([]);
    setSelectedEvents(null);
    setSelectedEventID(null);
    setTableData([]);

    setReload(!reload);


  }
  const handleDeleteUser = (userid, discipline_id, college_course_type) => {
    setDeleteUserID(userid);
    setDeleteUserDiscID(discipline_id);
    setDeleteUserCourseType(college_course_type);
    setDeleteUser(true);
  }
  const handleDeleteCancel = () => {
    setDeleteUser(false);
  }


  const handleDeleteSuccess = async () => {
    http
      .post('/College/deleteCollegeUser', {
        college_id: cid,
        userid: deleteUserID,
        discipline_id: deleteUserDiscID,
        college_course_type: deleteUserCourseType
      })
      .then((response) => {
        if (response.data.status_code === "MSG3") {
          setDeleteUser(false);
          sessionStorage.setItem("message", "User deleted successfully");
          toast.success("User data deleted successfully");
          //window.location.reload();
          setReload(!reload);

        }
      })
      .catch((error) => {
        const status = error.response?.data?.http_status;
        const code = error.response?.data?.status_code;
        const message = error.response?.data?.message || "An error occurred";
        setDeleteUser(false);
        if (code === "ERR_COURSE" && status === 500) {
          toast.error("Deletion not allowed. The user has courses that are already approved.");
        } else if (status === 500 || code === "ERR5") {
          toast.error("No user found");
        } else if (status === 403 && code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/college/"), 5000);
        } else {
          toast.error(message);
        }
      });
  };
  const encodeID = id => {
    return btoa(id);
  };


  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      textAlign: 'left', // added

    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '180px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
      textAlign: 'left', // added

    }),

    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
        textAlign: 'left', // added

      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };

  const formatDateTime = (dateTime) => {
    if (!dateTime) return '-';

    // Ensure space exists between date and time
    const normalized = dateTime.replace(
      /^(\d{4}-\d{2}-\d{2})(\d{2}:)/,
      '$1 $2'
    );

    const date = new Date(normalized.replace(' ', 'T'));

    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', '');
  };


  return (
    <>
      <ToastContainer />
      <Template>
        <div className="container-fluid">
          <div className="row">
            <div className="table-responsive">
              <div className="card">
                <div className="col-md-12">
                  <div className="card-header">
                    <div className="py-3 d-flex justify-content-between align-items-center">
                      <h5>Updated Events in College Level</h5>
                    </div>
                  </div>
                  <div className="card-body">
                    {/* <div className="table-responsive"> */}


                    <div className="table-responsive">

                      <div className="row align-items-center pdg18">
                        {/* Left 6 columns */}
                        <div className="col-md-8">
                          <div className="row align-items-center">
                            <div className="col-md-6">
                              <label>Events</label>
                              <Select
                                maxMenuHeight={200}
                                menuPlacement="auto"
                                id="discipline_id"
                                name="discipline_id"
                                className="form"
                                placeholder="Search with event..."
                                isSearchable={true}
                                isClearable={true}
                                styles={customStyles}
                                onChange={handleEventChange}
                                options={flag
                                  ? [{ value: '0', label: 'No data found' }]
                                  : allActiveEvents
                                    .sort((a, b) => a.event_name.localeCompare(b.event_name))
                                    .map(event => ({
                                      value: event.id,
                                      label: event.event_name,
                                    }))
                                }
                                value={selectedEvents}
                              />
                            </div>

                            <div className="col-md-6 d-flex align-self-end">
                              <button
                                type="button"
                                className="btn btn-secondary clear-btn ms-2"
                                onClick={handleClearFields}
                              >
                                Clear
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* Right 6 columns */}
                        <div className="col-md-4 d-flex justify-content-end">
                          <div className="d-flex gap-2">
                            <Link
                              className="btn custom-btn btn-primary common-btn d-inline-flex align-items-center justify-content-center"
                              to="/admin/collegeleveleventsadd"
                              title="Update New Event"
                            >
                              <i className="bi bi-plus-square ctm-btn-sz m-r-5"></i>Add Event
                            </Link>


                          </div>
                        </div>
                      </div>
                      <div className='row'>


                      </div>
                      <div className='row'>

                        <div className='col-md-6 wdt' >
                          <p>
                            Showing {(currentPage - 1) * 50 + 1}{''}-
                            {Math.min((currentPage - 1) * 50 + 50, total_count)} of {total_count} entries
                          </p>
                        </div>
                        <div className='col-md-6 wdt' align='right'>
                          <input
                            type="text"
                            value={searchQuery}
                            onChange={handleSearchInputChange}
                            placeholder="Search..."
                            className='form-control'
                          /></div></div>
                      <div class="table-containerq" style={{ overflowX: 'unset' }}>

                        <table className="display dataTable table-striped table-bordered ex-v-table " ref={tableRef}>
                          <thead>
                            <tr className="bg-primary">

                              <th onClick={() => handleSort('course_id')} scope="col" data-label="SL No" width="5%">Sl No &nbsp;
                                {renderSortIcon('course_id')} </th>
                              <th onClick={() => handleSort('college_name')} scope="col" data-label="College" width="20%">College&nbsp;
                                {renderSortIcon('college_name')} </th>
                              <th onClick={() => handleSort('event_name')} scope="col" data-label="event_name " width="">Event&nbsp;
                                {renderSortIcon('event_name')} </th>

                              <th onClick={() => handleSort('scheme_id')} scope="col" data-label="Discipline Type" width="">Admission Year, Semsester & Scheme &nbsp;
                                {renderSortIcon('scheme_id')} </th>
                              <th onClick={() => handleSort('start_date')} scope="col" data-label="start_date" width="" > Start Date&nbsp;
                                {renderSortIcon('start_date')} </th>
                              <th onClick={() => handleSort('end_date')} scope="col" data-label="end_date" width="" > End Date&nbsp;
                                {renderSortIcon('end_date')} </th>
                              <th onClick={() => handleSort('status')} scope="col" data-label="Status" width="" > Current Status &nbsp;
                                {renderSortIcon('status')} </th>

                              <th scope="col" data-label="Action" width="">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredAndSortedData.length > 0 ? (

                              filteredAndSortedData.map((item, index) => (

                                <tr className="grouped-row">
                                  <td>{index + 1}</td>
                                  <td>{item.college_name}</td>
                                  <td>{item.event_name}</td>

                                  <td>
                                    {item.admission_year && (
                                      <>
                                        <b>Year:</b> {item.admission_year} <br />
                                      </>
                                    )}
                                    {item.semester_id && (
                                      <>
                                        <b>Semester:</b> {item.semester_id} <br />
                                      </>
                                    )}
                                    <b>Scheme</b>{': '}
                                    {item.scheme_id === 1
                                      ? "MGU-UGP"
                                      : item.scheme_id === 2
                                        ? "BBA"
                                        : item.scheme_id === 3
                                          ? "BCA"
                                          : item.scheme_id === 4
                                            ? "B.Voc"
                                            : "N/A"}
                                  </td>

                                  <td>{formatDateTime(item.start_date)}</td>
                                  <td>{formatDateTime(item.end_date)}</td>
                                  <td style={{ textAlign: 'center' }}>{item.status}</td>
                                  <td>
                                    <div className="action-cell">
                                      <label className="switch m-l-10" title="Active/Close" style={{ marginTop: '10px' }}>
                                        <input
                                          type="checkbox"
                                          checked={item.status === 'active'}
                                          onChange={() =>
                                            handleToggleStatus(
                                              item.id,
                                              item.status
                                            )
                                          }
                                        />
                                        <span className="slider round"></span>
                                      </label>
                                      {/* <i className="fa fa-trash icn-out-bod" aria-hidden="true"
                                        onClick={() => handleDeleteUser(item.id, item.discipline_id, item.college_course_type)}
                                        style={{ cursor: 'pointer', marginBottom: "10px" }}
                                        title="Delete"></i> */}


                                      <Link to={`/admin/collegeleveleventsedit/${encodeID(item.id)}`} title="Edit" className="edit-btn">
                                        <i className="icon-pencil-alt"></i>
                                        {/* <span>Edit</span> */}

                                      </Link>


                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="8" className="text-center">No data found</td>
                              </tr>
                            )}
                          </tbody>


                        </table>
                      </div>

                      {totalPages > 1 && (
                        <nav aria-label="..." style={{ cursor: "pointer" }}>
                          <ul className="pagination justify-content-center">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                              <span className="page-link pgn-clr" onClick={handlePreviousPage}><i class="bi bi-arrow-left-circle-fill"></i></span>
                            </li>
                            <li className={`page-item`}>
                              <span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
                            </li>
                            {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                            {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
                              <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                              </li>
                            ))}
                            {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

                            <li className={`page-item`}>
                              <span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
                            </li>

                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                              <span className="page-link pgn-clr" onClick={handleNextPage}><i class="bi bi-arrow-right-circle-fill"></i></span>
                            </li>
                          </ul>
                        </nav>
                      )}


                      {/*  Delete User */}
                      <div className={`modal fade show ${isDeleteUser ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                          <div className="modal-content">
                            <div className="modal-body">
                              <div className="modal-toggle-wrapper">
                                {/* <ul className="modal-img">
                                  <li> <img src={logo} /></li>
                                </ul> */}
                                <h4 className="text-center pb-2">Are you sure you want to delete?</h4>
                                <p className="text-center">This action cannot be undone. Please confirm if you want to proceed with the deletion.</p>
                                <div className="d-flex justify-content-center mt-3">
                                  <button className="btn btn-danger mx-2" onClick={() => handleDeleteSuccess()}>Delete</button>
                                  <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleDeleteCancel()}>Cancel</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*  Delete User End */}


                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Template>
    </>
  );
}
